import { Button } from './Button';

export const ComponentGS = {
  Button: Button,
};
